import { useApiQuery } from "app/modules/api-client";

import { useAdsAlertsQueryParams } from "./useAdsAlertsQueryParams";

export const useAdsAlerts = () => {
    const params = useAdsAlertsQueryParams();

    const { data, ...rest } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsAdsDetail",
            options: {
                refetchOnMount: true,
            },
        },
        params,
    );

    return { data: data ?? [], ...rest };
};
